module.exports = __webpack_public_path__ + "img/facebook.ceeba6be.svg";